import { ArrowRight } from "lucide-react";

export default function Opportunity() {
  return (
    <section id="opportunite" className="bg-[var(--pc-bg-soft)] border-y pc-line">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="flex items-center gap-3 mb-7" data-testid="opportunity-eyebrow">
          <span className="tricolor-stripe !h-2.5" aria-hidden />
          <span className="text-[11.5px] tracking-[0.18em] uppercase pc-text-muted font-semibold">L'opportunité</span>
        </div>

        <h2 className="display-2 pc-text-ink text-balance max-w-5xl" data-testid="opportunity-h2">
          L&apos;État mobilise{" "}
          <span className="font-serif-num pc-text-blue font-semibold">150&nbsp;millions&nbsp;€</span> pour les entreprises
          françaises au titre du FIPU.
          <span className="block pc-text-muted mt-2 font-serif-emph">La majorité n&apos;ont pas encore été réclamés.</span>
        </h2>

        <div className="mt-14 max-w-3xl">
          <p className="text-[20px] sm:text-[22px] leading-[1.5] pc-text-ink text-pretty">
            Votre entreprise y a probablement droit.<br />
            <span className="pc-text-muted">Et personne ne vous a prévenu.</span>
          </p>

          <a href="#form-final" className="mt-9 btn-link-blue inline-flex items-center gap-1.5" data-testid="opportunity-cta">
            Voir si je peux y prétendre
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
